import { render, staticRenderFns } from "./eightCentresContentDetail.vue?vue&type=template&id=94c31b00"
import script from "./eightCentresContentDetail.vue?vue&type=script&lang=js"
export * from "./eightCentresContentDetail.vue?vue&type=script&lang=js"
import style0 from "./eightCentresContentDetail.vue?vue&type=style&index=0&id=94c31b00&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports